/* eslint-disable linebreak-style */
import React from 'react';

function About() {
  return (
    <>
      <div className="d-flex justify-content-center align-items-center">
        <p className="text-white p-5 m-5 text-center">
          Dev Finder is a platform for professionals to find and vet developers
          across specialties. Finding a developer can be challenging.
        </p>
      </div>
    </>
  );
}

export default About;
